import { useLocation } from "react-router-dom";

export default function Done() {
  const location = useLocation();
  const decision = location.state?.decision as
    | "approved"
    | "rejected"
    | "changes_requested"
    | undefined;
  const message = location.state?.message as string | undefined;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      <div className="text-center">
        {decision === "approved" ? (
          <>
            <div className="text-6xl mb-4">&#10003;</div>
            <h1 className="text-3xl font-bold text-green-400 mb-4">Approved</h1>
            <p className="text-gray-400 max-w-md">
              {message ||
                "The episode has been approved and will proceed to final delivery."}
            </p>
          </>
        ) : decision === "rejected" ? (
          <>
            <div className="text-6xl mb-4">&#10007;</div>
            <h1 className="text-3xl font-bold text-red-400 mb-4">Rejected</h1>
            <p className="text-gray-400 max-w-md">
              {message || "The pipeline has been stopped."}
            </p>
          </>
        ) : decision === "changes_requested" ? (
          <>
            <div className="text-6xl mb-4">&#8634;</div>
            <h1 className="text-3xl font-bold text-yellow-400 mb-4">
              Changes Requested
            </h1>
            <p className="text-gray-400 max-w-md">
              {message ||
                "Your feedback has been submitted. The team will address your notes."}
            </p>
          </>
        ) : (
          <>
            <div className="text-6xl mb-4">&#10003;</div>
            <h1 className="text-3xl font-bold text-white mb-4">
              Review Submitted
            </h1>
            <p className="text-gray-400 max-w-md">
              {message ||
                "Your decision has been recorded. You can close this window."}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
